[data-api-page] a,
[data-api-page] [role="tab"],
[data-api-page] [role="button"] {
  transition: background-color 160ms ease, border-color 160ms ease, opacity 160ms ease;
}

[data-api-page] a:focus-visible,
[data-api-page] [role="tab"]:focus-visible,
[data-api-page] [role="button"]:focus-visible,
[data-api-page] [role="tabpanel"]:focus-visible {
  outline: 2px solid #0071e3 !important;
  outline-offset: 3px;
}

[data-api-page="dark"] :focus-visible {
  outline-color: #8cbcff !important;
}

@media (prefers-reduced-motion: reduce) {
  [data-api-page] * { transition: none !important; }
}
